export default {
    "阿富汗": "阿富汗",
    "奥兰群岛": "奥兰群岛",
    "阿尔巴尼亚": "阿尔巴尼亚",
    "阿尔及利亚": "阿尔及利亚",
    "美属萨摩亚": "美属萨摩亚",
    "安道尔": "安道尔",
    "安哥拉": "安哥拉",
    "安圭拉": "安圭拉",
    "南极洲": "南极洲",
    "安提瓜和巴布达": "安提瓜和巴布达",
    "阿根廷": "阿根廷",
    "亚美尼亚": "亚美尼亚",
    "阿鲁巴": "阿鲁巴",
    "阿森松岛": "阿森松岛",
    "澳大利亚": "澳大利亚",
    "奥地利": "奥地利",
    "阿塞拜疆": "阿塞拜疆",
    "巴林": "巴林",
    "孟加拉国": "孟加拉国",
    "巴巴多斯": "巴巴多斯",
    "白俄罗斯": "白俄罗斯",
    "比利时": "比利时",
    "伯利兹": "伯利兹",
    "贝宁": "贝宁",
    "百慕大": "百慕大",
    "不丹": "不丹",
    "玻利维亚": "玻利维亚",
    "波黑": "波黑",
    "博茨瓦纳": "博茨瓦纳",
    "巴西": "巴西",
    "英属维尔京群岛": "英属维尔京群岛",
    "文莱": "文莱",
    "保加利亚": "保加利亚",
    "布基纳法索": "布基纳法索",
    "缅甸": "缅甸",
    "布隆迪": "布隆迪",
    "柬埔寨": "柬埔寨",
    "喀麦隆": "喀麦隆",
    "加拿大": "加拿大",
    "佛得角": "佛得角",
    "荷兰加勒比区": "荷兰加勒比区",
    "开曼群岛": "开曼群岛",
    "中非": "中非",
    "乍得": "乍得",
    "智利": "智利",
    "中国": "中国",
    "圣诞岛": "圣诞岛",
    "科科斯（基林）群岛": "科科斯（基林）群岛",
    "哥伦比亚": "哥伦比亚",
    "科摩罗": "科摩罗",
    "刚果（金）": "刚果（金）",
    "刚果（布）": "刚果（布）",
    "库克群岛": "库克群岛",
    "哥斯达黎加": "哥斯达黎加",
    "科特迪瓦": "科特迪瓦",
    "克罗地亚": "克罗地亚",
    "古巴": "古巴",
    "库拉索": "库拉索",
    "塞浦路斯": "塞浦路斯",
    "捷克": "捷克",
    "丹麦": "丹麦",
    "吉布提": "吉布提",
    "多米尼克": "多米尼克",
    "多米尼加": "多米尼加",
    "厄瓜多尔": "厄瓜多尔",
    "埃及": "埃及",
    "萨尔瓦多": "萨尔瓦多",
    "赤道几内亚": "赤道几内亚",
    "厄立特里亚": "厄立特里亚",
    "爱沙尼亚": "爱沙尼亚",
    "埃塞俄比亚": "埃塞俄比亚",
    "福克兰群岛（马尔维纳斯）": "福克兰群岛（马尔维纳斯）",
    "法罗群岛": "法罗群岛",
    "斐济": "斐济",
    "芬兰": "芬兰",
    "法国": "法国",
    "法属圭亚那": "法属圭亚那",
    "法属波利尼西亚": "法属波利尼西亚",
    "加蓬": "加蓬",
    "格鲁吉亚": "格鲁吉亚",
    "德国": "德国",
    "加纳": "加纳",
    "直布罗陀": "直布罗陀",
    "希腊": "希腊",
    "格陵兰": "格陵兰",
    "格林纳达": "格林纳达",
    "瓜德罗普": "瓜德罗普",
    "关岛": "关岛",
    "危地马拉": "危地马拉",
    "根西岛": "根西岛",
    "几内亚": "几内亚",
    "几内亚比绍": "几内亚比绍",
    "圭亚那": "圭亚那",
    "海地": "海地",
    "梵蒂冈": "梵蒂冈",
    "洪都拉斯": "洪都拉斯",
    "香港": "香港",
    "匈牙利": "匈牙利",
    "冰岛": "冰岛",
    "印度": "印度",
    "印度尼西亚": "印度尼西亚",
    "伊朗": "伊朗",
    "伊拉克": "伊拉克",
    "爱尔兰": "爱尔兰",
    "以色列": "以色列",
    "意大利": "意大利",
    "牙买加": "牙买加",
    "日本": "日本",
    "约旦": "约旦",
    "哈萨克斯坦": "哈萨克斯坦",
    "肯尼亚": "肯尼亚",
    "基里巴斯": "基里巴斯",
    "朝鲜": "朝鲜",
    "韩国": "韩国",
    "科威特": "科威特",
    "吉尔吉斯斯坦": "吉尔吉斯斯坦",
    "老挝": "老挝",
    "拉脱维亚": "拉脱维亚",
    "黎巴嫩": "黎巴嫩",
    "莱索托": "莱索托",
    "利比里亚": "利比里亚",
    "利比亚": "利比亚",
    "列支敦士登": "列支敦士登",
    "立陶宛": "立陶宛",
    "卢森堡": "卢森堡",
    "澳门": "澳门",
    "前南马其顿": "前南马其顿",
    "马达加斯加": "马达加斯加",
    "马拉维": "马拉维",
    "马来西亚": "马来西亚",
    "马尔代夫": "马尔代夫",
    "马里": "马里",
    "马耳他": "马耳他",
    "马绍尔群岛": "马绍尔群岛",
    "马提尼克": "马提尼克",
    "毛里塔尼亚": "毛里塔尼亚",
    "毛里求斯": "毛里求斯",
    "马约特": "马约特",
    "墨西哥": "墨西哥",
    "密克罗尼西亚": "密克罗尼西亚",
    "摩尔多瓦": "摩尔多瓦",
    "摩纳哥": "摩纳哥",
    "蒙古": "蒙古",
    "蒙特塞拉特": "蒙特塞拉特",
    "摩洛哥": "摩洛哥",
    "莫桑比克": "莫桑比克",
    "纳米尼亚": "纳米尼亚",
    "瑙鲁": "瑙鲁",
    "尼泊尔": "尼泊尔",
    "荷兰": "荷兰",
    "荷属安的列斯": "荷属安的列斯",
    "新喀里多尼亚": "新喀里多尼亚",
    "新西兰": "新西兰",
    "尼加拉瓜": "尼加拉瓜",
    "尼日尔": "尼日尔",
    "尼日利亚": "尼日利亚",
    "纽埃": "纽埃",
    "诺福克岛": "诺福克岛",
    "北马里亚纳": "北马里亚纳",
    "挪威": "挪威",
    "阿曼": "阿曼",
    "巴基斯坦": "巴基斯坦",
    "帕劳": "帕劳",
    "巴拿马": "巴拿马",
    "巴布亚新几内亚": "巴布亚新几内亚",
    "巴拉圭": "巴拉圭",
    "秘鲁": "秘鲁",
    "菲律宾": "菲律宾",
    "波兰": "波兰",
    "葡萄牙": "葡萄牙",
    "波多黎各": "波多黎各",
    "卡塔尔": "卡塔尔",
    "留尼汪": "留尼汪",
    "罗马尼亚": "罗马尼亚",
    "俄罗斯": "俄罗斯",
    "卢旺达": "卢旺达",
    "圣赫勒拿": "圣赫勒拿",
    "圣基茨和尼维斯": "圣基茨和尼维斯",
    "圣卢西亚": "圣卢西亚",
    "圣皮埃尔和密克隆": "圣皮埃尔和密克隆",
    "圣文森特和格林纳丁斯": "圣文森特和格林纳丁斯",
    "萨摩亚": "萨摩亚",
    "圣马力诺": "圣马力诺",
    "圣多美和普林西比": "圣多美和普林西比",
    "沙特阿拉伯": "沙特阿拉伯",
    "塞内加尔": "塞内加尔",
    "塞尔维亚": "塞尔维亚",
    "塞舌尔": "塞舌尔",
    "塞拉利昂": "塞拉利昂",
    "新加坡": "新加坡",
    "斯洛伐克": "斯洛伐克",
    "斯洛文尼亚": "斯洛文尼亚",
    "所罗门群岛": "所罗门群岛",
    "索马里": "索马里",
    "南非": "南非",
    "西班牙": "西班牙",
    "斯里兰卡": "斯里兰卡",
    "苏丹": "苏丹",
    "苏里南": "苏里南",
    "斯瓦尔巴岛和扬马延岛": "斯瓦尔巴岛和扬马延岛",
    "斯威士兰": "斯威士兰",
    "瑞典": "瑞典",
    "瑞士": "瑞士",
    "叙利亚": "叙利亚",
    "台湾": "台湾",
    "塔吉克斯坦": "塔吉克斯坦",
    "坦桑尼亚": "坦桑尼亚",
    "泰国": "泰国",
    "巴哈马": "巴哈马",
    "冈比亚": "冈比亚",
    "多哥": "多哥",
    "托克劳": "托克劳",
    "汤加": "汤加",
    "特立尼达和多巴哥": "特立尼达和多巴哥",
    "突尼斯": "突尼斯",
    "土耳其": "土耳其",
    "土库曼斯坦": "土库曼斯坦",
    "特克斯和凯科斯群岛": "特克斯和凯科斯群岛",
    "图瓦卢": "图瓦卢",
    "乌干达": "乌干达",
    "乌克兰": "乌克兰",
    "阿拉伯联合酋长国": "阿拉伯联合酋长国",
    "英国": "英国",
    "美国": "美国",
    "乌拉圭": "乌拉圭",
    "乌兹别克斯坦": "乌兹别克斯坦",
    "瓦努阿图": "瓦努阿图",
    "委内瑞拉": "委内瑞拉",
    "越南": "越南",
    "美属维尔京群岛": "美属维尔京群岛",
    "瓦利斯和富图纳": "瓦利斯和富图纳",
    "也门": "也门",
    "赞比亚": "赞比亚",
    "津巴布韦": "津巴布韦"
}